uniform float time;
uniform vec2 uHover;
uniform float uHoverState;
varying vec2 vUv;
varying vec3 vPosition;
uniform vec2 pixels;
uniform float distortion;
float PI = 3.141592653589793238;
void main() {
  vUv = uv;
  
  vec3 newpos = position;

  float dist = distance(uv, uHover);


    


  float distanceFromCenter = abs(
    (modelMatrix * vec4(position, 1.0)).y
  );

  float smo = abs(distortion)*0.7*smoothstep(2.,0.,distanceFromCenter);


newpos.z += smo;

newpos.z += 0.03*(uHoverState ) * sin(dist * 10.0 + (time * 1.5));

  vPosition = position;
  gl_Position = projectionMatrix * modelViewMatrix * vec4( newpos, 1.0 );
}